export default {
	getAllPropertyData(state) {
		return state.propertyData;
	},
	getOrderForm(state) {
		return state.orderFormData;
	},
	getOrderFormEditable(state, data) {
		return state.isOrderFromEditable;
	},
	// getter for order status
	getCaseData(state) {
		return state.caseData;
	},
	getAssessmentRate(state) {
		return state.propertyData.assessmentRate;
	},
	getAssessmentRateText(state) {
		switch (state.propertyData.assessmentRate) {
			// assessmentStatus.underassessed: // "Underasssesed":
			// assessmentStatus.overAssessed: // "Overassessed":
			// assessmentStatus.fairlyAssessed: // "Asssesed Fairly":
			// assessmentStatus.notAssessed:// "notAssessed":
			case 1:
				return "Fairly Asssesed";
				break;
			case 2:
				return "Fairly Asssesed";
				break;
			case 3:
				return "Over Assessed";
				break;
			case 0:
				return "Not Assessed";
				break;
			default:
				return "Not Assessed";
				break;
		}
	},
};
